// "Tem código de criador?" — tela 8 (planos), iOS e Android.
//
// O código NÃO muda preço na loja: só atribui a assinatura ao criador. Ele vai
// como atributo `affiliate_code` do RevenueCat, gravado ANTES da compra
// (lojaPlanos.comprarPacote), que é o que o backend lê para a comissão.
//
// Conta que já tem vínculo (AFFILIATE_APPLIED + AFFILIATE_CODE): o código
// aparece preenchido e travado. Sem vínculo: link discreto que expande o
// campo; a validação é a MESMA do paywall antigo (Sliders):
// GET /pay/stripe/validate-coupon.

import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../config/api';
import haptics from '../../design/feedback/haptics';
import s from './CodigoCriador.module.scss';

export default function CodigoCriador({ codigoDaConta, onMudar }) {
  const travado = !!codigoDaConta;
  const [aberto, setAberto] = useState(travado);
  const [texto, setTexto] = useState(codigoDaConta || '');
  const [status, setStatus] = useState(travado ? 'valido' : 'idle'); // idle|carregando|valido|invalido
  const [mensagem, setMensagem] = useState('');

  useEffect(() => {
    if (travado) {
      setTexto(codigoDaConta);
      setStatus('valido');
      setAberto(true);
      onMudar?.(codigoDaConta);
    }
    // onMudar é estável no pai; o vínculo da conta é o que importa aqui.
  }, [travado, codigoDaConta]); // eslint-disable-line

  const validar = async () => {
    const codigo = texto.trim().toUpperCase();
    if (!codigo) {
      setStatus('invalido');
      setMensagem('Digite o código.');
      return;
    }
    setStatus('carregando');
    setMensagem('');
    onMudar?.('');
    try {
      const res = await fetch(
        `${API_BASE_URL}/pay/stripe/validate-coupon?coupon_code=${encodeURIComponent(codigo)}`,
      );
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.valid) {
        haptics.success?.();
        setStatus('valido');
        setTexto(codigo);
        onMudar?.(codigo);
      } else {
        haptics.error?.();
        setStatus('invalido');
        setMensagem(data.message || 'Código inválido ou expirado.');
      }
    } catch {
      setStatus('invalido');
      setMensagem('Não foi possível verificar o código. Tente de novo.');
    }
  };

  if (!aberto) {
    return (
      <button type="button" className={s.link} onClick={() => setAberto(true)}>
        Tem código de criador?
      </button>
    );
  }

  return (
    <div className={s.card}>
      <label className={s.rotulo} htmlFor="codigo-criador">Código de criador</label>
      <div className={s.linha}>
        <input
          id="codigo-criador"
          className={s.campo}
          value={texto}
          disabled={travado || status === 'carregando'}
          autoCapitalize="characters"
          autoComplete="off"
          maxLength={40}
          onChange={(e) => {
            setTexto(e.target.value.toUpperCase());
            if (status !== 'idle') {
              setStatus('idle');
              onMudar?.('');
            }
          }}
          onKeyDown={(e) => { if (e.key === 'Enter') validar(); }}
        />
        {!travado && (
          <button
            type="button"
            className={s.aplicar}
            disabled={status === 'carregando' || status === 'valido'}
            onClick={validar}
          >
            {status === 'carregando' ? '…' : status === 'valido' ? '✓' : 'Aplicar'}
          </button>
        )}
      </div>
      {travado && <p className={s.nota}>Vinculado à sua conta.</p>}
      {!travado && status === 'valido' && <p className={s.ok}>Código aplicado.</p>}
      {status === 'invalido' && <p className={s.erro} role="alert">{mensagem}</p>}
      <p className={s.nota}>O código não muda o preço na loja.</p>
    </div>
  );
}
